import { useEffect, useMemo, useRef } from "react";

// taken from https://decipher.dev/30-seconds-of-typescript/docs/debounce/
const debounce = (fn: Function, ms = 300) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function (this: any, ...args: any[]) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
  };

// taken from https://www.developerway.com/posts/debouncing-in-react
export const useDebounceState = (callback: () => void, timeout: number) => {
    const ref = useRef<any>();
  
    useEffect(() => {
      ref.current = callback;
    }, [callback]);
  
    const debouncedCallback = useMemo(() => {
      const func = () => {
        ref.current?.();
      };
      
      return debounce(func, timeout);
    }, [timeout]); // eslint complained about timeout not being here, so I added it to silence the warning even though I don't expect this to change
  
    return debouncedCallback;
  };

